import { useEffect, useMemo } from 'react'
import AppStateHandler from 'src/StateHandlers/AppStateHandler'

function useLoading(_status: string) {
  const status = useMemo(() => _status, [_status]);
  useEffect(() => {
    if (status === 'loading') {
      AppStateHandler.startLoader();
    } else {
      AppStateHandler.stopLoader();
    }

  }, [status])
}

export default useLoading
